import React from 'react';
import { Box, Button, ButtonGroup, Container, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import i18n from '../../i18n';
function TermsOfService(props) {
    return (
        <Container>
            <Box sx={{ textAlign: 'justify' }}>
                <Typography variant="h4" gutterBottom align={'center'} mt={5}>
                    Terms of service
                </Typography>

                {/* TODO add terms of service */}
            </Box>

            <ButtonGroup
                sx={{
                    marginTop: 5,
                    marginBottom: 5,
                    justifyContent: 'space-between'
                }}
                variant="outlined"
                color="primary"
            >
                <Button
                    component={Link}
                    to="/dashboard"
                    startIcon={<ArrowBackIcon />}
                >
                    {i18n.t('common.back')}
                </Button>
                <Button component={Link} to="/docs/privasy">
                    {i18n.t('common.privacy')}
                </Button>
            </ButtonGroup>
        </Container>
    );
}

export default TermsOfService;
